<mat-chip>
    <ng-content select="[data-label]"></ng-content>
    <ng-content select="[data-action]"></ng-content>
</mat-chip>